import '@/styles/ranking-layout.css';
import { RankingSidebar } from './RankingSidebar';

interface RankingShellProps {
  title?: string;
}

export function RankingShell({ title }: RankingShellProps) {
  return (
    <div className="container-ingame fade-in ranking-layout">
      <RankingSidebar />
      <main className="ranking-content">
        {title ? <h2 className="ranking-title">{title}</h2> : null}
      </main>
    </div>
  );
}
